import { z } from 'zod';
import { apiUrl } from '../config/api';
import type { Order } from '../data/databaseSchema';
import { apiClient } from '../lib/apiClient';
import { apiResponseSchema, orderSchema } from '../lib/schemas';

// Order administration moved to another application; only reads remain.
export const orderService = {
  getOrders: async (): Promise<Order[]> => {
    const result = await apiClient.get(apiUrl.orders(), {
      validate: apiResponseSchema(z.array(orderSchema)),
      deduplicate: true,
      context: 'getOrders',
    });
    return result.data;
  },

  getOrdersByProject: async (projectId: string): Promise<Order[]> => {
    const result = await apiClient.get(apiUrl.projectOrders(projectId), {
      validate: apiResponseSchema(z.array(orderSchema)),
      deduplicate: true,
      context: 'getOrdersByProject',
    });
    return result.data;
  },
};
